import { getHours } from 'date-fns';
import type { UserInformation } from '@/common/types/user';

export const getGreeting = (
  props?: Pick<UserInformation, 'displayName' | 'firstName'>,
) => {
  let greeting = 'Good evening';
  const name = props?.displayName?.length
    ? props.displayName
    : props?.firstName;

  const currentHour = getHours(new Date());
  if (currentHour >= 5 && currentHour < 12) greeting = 'Good morning';

  if (currentHour >= 12 && currentHour < 17) greeting = 'Good afternoon';

  if (name) greeting += `, ${name}`;

  return greeting;
};
